export const evaluateTimeReadOnlyCondition = (path, readOnly, dataCondition, title) => {
    if (path === '/publish') {
      if (readOnly || dataCondition) return title === 'Time';
    }
    return false;
  };
  